// extracted by mini-css-extract-plugin
module.exports = {"container":"Contact_container__3utcT","heading":"Contact_heading__3SKrN","header":"Contact_header__2mnuc","number":"Contact_number__2rESj","contact":"Contact_contact__fuqV-"};